import { useRegisterSW } from 'virtual:pwa-register/react'
import { Button } from '@/components/ui'
import { useT } from '@/i18n/useT'

/**
 * With registerType 'autoUpdate' a new build activates on its own, so this is
 * now a fallback for the case where the worker updated but the page did not
 * reload -- not the primary path. It was the primary path, and clients sat on
 * stale code for hours because nobody clicked the button.
 */
export function UpdatePrompt() {
  const t = useT()
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError: (error) => console.error('[pwa] sw registration failed', error),
  })

  if (!needRefresh) return null

  return (
    <div
      role="status"
      className="surface-raised border-hair fixed inset-x-3 bottom-20 z-50 flex items-center gap-3 rounded-2xl border p-3 shadow-lg"
    >
      <p className="flex-1 text-sm">{t('update.ready')}</p>
      <Button size="sm" variant="ghost" onClick={() => setNeedRefresh(false)}>
        {t('update.later')}
      </Button>
      <Button size="sm" onClick={() => void updateServiceWorker(true)}>
        {t('update.reload')}
      </Button>
    </div>
  )
}
